import React from 'react';
import _ from 'lodash';
import FreemiumCard from './freemium_card';
import SubscriptionDetails from './subscription_details';
import classNames from 'classnames'

import CurrentAddon from './current_addon';
import AutoCreditReplenishmentCard from './auto_credit_replenishment_card';
import RecurringCoupon from './recurring_coupon';


const UserPlans = ({ additionalUserData, userData }) => {

  const subscriptions = _.get(additionalUserData, 'subscription_details', []);

  const plan = _.find(subscriptions, s => _.get(s, 'product_type') === 'plan');

  const acrData = userData?.payment?.auto_charge?.credits;

  const totalPrice = _.get(plan, 'price.total_price', 0);
  const isFreemium = plan && totalPrice === 0;

  return (
    <div
      className={classNames('user-subscription', {
        'user-subscription--freemium': isFreemium,
        'user-subscription--paid': plan && !isFreemium
      })}
    >

      {plan && (
        isFreemium
          ? <FreemiumCard plan={plan} />
          : <SubscriptionDetails plan={plan} />
      )}
      <AutoCreditReplenishmentCard acrData={acrData} />
      <RecurringCoupon userData={userData} />
      <CurrentAddon subscriptionDetails={subscriptions} />

    </div>
  )
};

export default UserPlans;